export default {
    currentPage: function() {
        const self = this

        self.loadEvents()
    }
}
